import React from 'react';
import style from '../css/NewStudyMethod.module.css';

import { FaUsers, FaUserGraduate } from 'react-icons/fa';
import { IoDocumentText } from 'react-icons/io5';
import { BsCollectionPlayFill } from 'react-icons/bs';
import study1 from '../images/study1.png';
import study2 from '../images/study2.png';

import img1 from '../images/study-method/1.png'
import img2 from '../images/study-method/2.png'
import img3 from '../images/study-method/3.png'
import img4 from '../images/study-method/4.png'

const NewStudyMethod = () => {
	return (
		<section className={style.mainSection}>
			<div className={style.mainContainer}>
				<div className={style.imgsContainer1}>
					<div className={style.imgsContainer2}>
						<img className={style.img1} src={study1} alt='study1' />
						<img className={style.img2} src={study2} alt='study1' />
						<img
							className={style.imgPuntos}
							src='https://ifingerstudio.com/eduvalt/wp-content/themes/eduvalt/assets/img/others/about_dots.svg'
							alt='svg'
						/>

						<svg
							className={style.circle}
							width='344'
							height='344'
							viewBox='0 0 344 344'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<rect
								x='20'
								y='20'
								width='304'
								height='304'
								rx='152'
								stroke='currentcolor'
								stroke-width='40'
							></rect>
						</svg>

						<div className={style.box}>
							<svg
								width='126'
								height='108'
								viewBox='0 0 126 108'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M0 10C0 4.47715 4.47715 0 10 0H110.996C116.321 0 120.713 4.17312 120.983 9.4914L125.429 96.7793C125.733 102.754 120.758 107.657 114.789 107.267L9.34719 100.369C4.08901 100.025 0 95.6593 0 90.3899V10Z'
									fill='currentcolor'
								></path>
							</svg>
							<h4>
								25K{' '}
								<span>
									{' '}
									Resultados <br /> Sorprendentes
								</span>{' '}
							</h4>
						</div>
					</div>
				</div>
				<div className={style.textContainer}>
					<div className={style.bubble}>
						<span>Método de estudio</span>
					</div>

					<h1>
						{' '}
						Formamos <b> Especialistas 3D </b> online en vivo{' '}
					</h1>

					<p>
						Creamos un plan de estudios con Blender para ayudarte a obtener resultados excepcionales
						en menos tiempo, respaldado por una certificación universitaria.
					</p>

					<div className={style.cardsMainContainer}>
						<div className={style.cardContainer}>
							{/* <FaUsers style={{ color: '#2494e4' }} /> */}
							<img src={img1} alt="1" style={{maxWidth:'40px'}}/>
							<h2>
								6 Meses <br /> Online en vivo
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <IoDocumentText style={{ color: '#219653' }} /> */}
							<img src={img2} alt="2" style={{maxWidth:'40px'}}/>
							<h2>
								Material <br /> de ayuda
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <FaUserGraduate style={{ color: '#9B51E0' }} /> */}
							<img src={img3} alt="3" style={{maxWidth:'40px'}}/>
							<h2>
								Doble <br /> Certificación
							</h2>
						</div>

						<div className={style.cardContainer}>
							{/* <BsCollectionPlayFill style={{ color: '#FF2E2E' }} /> */}
							<img src={img4} alt="4" style={{maxWidth:'40px'}}/>
							<h2>
								Actualizaciones
								<br /> Permanentes
							</h2>
						</div>
					</div>

					<a className={style.button1} href='https://calendly.com/d/cqc4-92f-xhg/asesoria-personalizada-gratuita'>
						AGENDA UNA REUNIÓN POR ZOOM
					</a>
				</div>
			</div>
		</section>
	);
};

export default NewStudyMethod;
